import React from 'react';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaGithub } from 'react-icons/fa';
import logo from '../assets/logoWhite512.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <div className="footer-logo">
              <img src={logo} alt="IdeasPoint - Business Consultancy" />
            </div>
            <p className="footer-description">
              Transforming business visions into digital reality with comprehensive 
              consultancy services across the globe.
            </p>
            <div className="social-links" role="navigation" aria-label="Social media links">
              <button className="social-link" onClick={() => console.log('Facebook')} aria-label="Visit our Facebook page">
                <FaFacebookF aria-hidden="true" />
              </button>
              <button className="social-link" onClick={() => console.log('Twitter')} aria-label="Visit our Twitter profile">
                <FaTwitter aria-hidden="true" />
              </button>
              <button className="social-link" onClick={() => console.log('LinkedIn')} aria-label="Visit our LinkedIn page">
                <FaLinkedinIn aria-hidden="true" />
              </button>
              <button className="social-link" onClick={() => console.log('Instagram')} aria-label="Visit our Instagram profile">
                <FaInstagram aria-hidden="true" />
              </button>
              <button className="social-link" onClick={() => console.log('GitHub')} aria-label="Visit our GitHub repository">
                <FaGithub aria-hidden="true" />
              </button>
            </div>
          </div>

          <nav className="footer-column" aria-label="Services navigation">
            <h4>Services</h4>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('services')}>Web Development</button></li>
              <li><button onClick={() => scrollToSection('services')}>Digital Marketing</button></li>
              <li><button onClick={() => scrollToSection('services')}>Brand Creation</button></li>
              <li><button onClick={() => scrollToSection('services')}>Business Consultation</button></li>
              <li><button onClick={() => scrollToSection('services')}>Data Analytics</button></li>
              <li><button onClick={() => scrollToSection('services')}>Design Creation</button></li>
            </ul>
          </nav>

          <nav className="footer-column" aria-label="Company navigation">
            <h4>Company</h4>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('about')}>About Us</button></li>
              <li><button onClick={() => scrollToSection('portfolio')}>Portfolio</button></li>
              <li><button onClick={() => scrollToSection('portfolio')}>Testimonials</button></li>
              <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
              <li><button onClick={() => console.log('Careers')}>Careers</button></li>
              <li><button onClick={() => console.log('Blog')}>Blog</button></li>
            </ul>
          </nav>

          <div className="footer-column">
            <h4>Newsletter</h4>
            <p>Subscribe to get the latest updates and insights.</p>
            <form className="newsletter-form" onSubmit={(e) => e.preventDefault()} aria-label="Newsletter subscription">
              <label htmlFor="newsletter-email" className="visually-hidden">Email address</label>
              <input 
                type="email" 
                id="newsletter-email"
                placeholder="Your email address" 
                aria-label="Enter your email address for newsletter"
                required
              />
              <button type="submit" aria-label="Subscribe to newsletter">Subscribe</button>
            </form>
            <address className="footer-contact">
              <p><strong>Email:</strong> <a href="mailto:contact@ideaspoint.in">contact@ideaspoint.in</a></p>
              <p><strong>Phone:</strong> <a href="tel:+919867553336">+91 9867553336</a></p>
            </address>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} IdeasPoint. All rights reserved.</p>
          <nav className="footer-bottom-links" aria-label="Legal navigation">
            <button onClick={() => console.log('Privacy Policy')}>Privacy Policy</button>
            <button onClick={() => console.log('Terms')}>Terms of Service</button>
            <button onClick={() => console.log('Cookies')}>Cookie Policy</button>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
